import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-600c9819"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-main-detail" }
const _hoisted_2 = { class: "task-main-detail__header" }
const _hoisted_3 = {
  key: 0,
  class: "task-main-detail__header_estimate"
}
const _hoisted_4 = { class: "task-main-detail__subheader" }
const _hoisted_5 = { class: "task-main-detail__subheader-left" }
const _hoisted_6 = { class: "task-main-detail__subheader-info" }
const _hoisted_7 = { class: "task-main-detail__tooltip-text" }
const _hoisted_8 = {
  key: 0,
  class: "task-main-detail__author-id"
}
const _hoisted_9 = { class: "task-main-detail__subheader-description" }
const _hoisted_10 = { class: "task-main-detail__input-wrap" }
const _hoisted_11 = { class: "task-main-detail__tags" }
const _hoisted_12 = { class: "task-main-detail__users" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-main-detail__users-divider" }, null, -1))
const _hoisted_14 = { class: "task-main-detail__files" }

import { computed, CSSProperties, nextTick, onMounted, PropType, Ref, ref, watch } from 'vue';
import { TaskModel, TaskFormDataModel } from './models';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirDivider,
  TirPmScrollbar,
  PopoverColorEnum,
  TirPmPopover,
  PopoverPositionEnum,
  TirPmTooltipElement,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
} from 'tir-components';
import {
  ArrowUturnLeftIcon,
  ClipboardDocumentIcon,
  PencilSquareIcon,
  EllipsisHorizontalIcon,
  CrossCompactIcon,
  LinkIcon,
} from 'tir-style-system/icons/outline';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import tirPmDateTransform from 'tir-pm-date-transform';
import {
  TaskInputName,
  TaskTagsSelect,
  TaskEmployeeMultiselect,
  SubtasksSearchFunctionType,
  TaskFiles,
  TaskInputNameModeEnum,
  TaskMorePopover,
  TaskParentView,
  TaskRelations,
  TaskDrawerSettingsModel,
  TimeTrackerRecordModel,
} from '../index';
import { TaskDetailErrors } from './types';
import { TagModel, UserModel, SubtaskModel, TaskFileModel } from '../../models';
import { useRoute, useRouter } from 'vue-router';
import {
  FileUploadCallbackFunctionType,
  ITextEditorFile,
  TirPmTextEditorFile,
  TirPmTextEditorFilePreview,
} from 'tir-pm-texteditor-file';
import { onUnmounted } from 'vue';
import { inject } from 'vue';
import { FilePreviewAccessEnum } from 'tir-pm-file-preview';
import { FileManager } from 'tir-pm-file-upload-manager';
import { WeeekTag } from '@/components/weeek-tag';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from './models/GetAccessCurrentUserInQueueTaskByIdResponseModel';
import { copyToClipboard } from '../../utils';
import { TaskDialogEnum, TaskDialogModal } from '../task-dialog-modal';
import { ComponentInstance } from 'tir-pm-toolkit';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-main-detail',
  props: {
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
  /**Записи таймера */
  timerTrackerRecords: {
    type: Array as PropType<Array<TimeTrackerRecordModel>>,
    default: [],
  },
  /**Данные задачи */
  task: {
    type: Object as PropType<TaskModel>,
    required: true,
  },
  /**Список загружаемых файлов */
  uploadingFiles: {
    type: Array as PropType<Array<TaskFileModel>>,
    default: [],
  },
  /**Список тегов */
  tags: {
    type: Array as PropType<Array<TagModel>>,
    default: [],
  },
  /**Список сотрудников */
  employees: {
    type: Array as PropType<Array<UserModel>>,
    default: [],
  },
  /**Список подзадач */
  subtasks: {
    type: Array as PropType<Array<SubtaskModel>>,
    default: [],
  },
  /**Редактируемая задача */
  editTaskInfo: {
    type: Object as PropType<TaskModel>,
  },
  /**Данные формы */
  formData: {
    type: Object as PropType<TaskFormDataModel>,
    required: true,
  },
  /**Ошибки */
  errors: {
    type: Object as PropType<TaskDetailErrors>,
  },
  /**Отобразить все подзадачи */
  isViewAllSubtasks: {
    type: Boolean,
    default: false,
  },
  /**Игнорируемы подзадачи при поиске */
  ignoreSearchSubtasks: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Кол-во подзадач */
  countSubtasks: {
    type: Number,
    required: true,
  },
  /**Загрузка при показе всех подзадач */
  isLoadingShowAllSubtasks: {
    type: Boolean,
    default: false,
  },
  /**Функция поиска задач для добавляения */
  searchTasksToAttach: {
    type: Function as PropType<SubtasksSearchFunctionType>,
    required: true,
  },
  /**Функция поиска задач для смены родителя */
  searchTasksChangeParent: {
    type: Function as PropType<SubtasksSearchFunctionType>,
    required: true,
  },
  /**Функция для загрузки файла из описания */
  fileUploadCallbak: {
    type: Function as PropType<FileUploadCallbackFunctionType>,
    required: true,
  },
  /**Заблокировать кнопку создания */
  isDisableCreateButton: {
    type: Boolean,
    default: false,
  },
  /**Загрузка кнопки создания */
  isLoadingCreateButton: {
    type: Boolean,
    default: false,
  },
  /**Загрузка кнопки прикрепления файлов */
  isLoadingAttachFilesButton: {
    type: Boolean,
    default: false,
  },
  /**Загрузка при редактировании названия */
  filesLoadingEditName: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Загрузка при откреплении родительской задачи */
  isLoadingUnattachParent: {
    type: Boolean,
    default: false,
  },
  /**Загрузка при откреплении родительской задачи */
  editing: {
    type: Boolean,
    default: true,
  },
  /**Загрузка при откреплении подзадач */
  isLoadingUnattachSubtask: {
    type: Set as PropType<Set<number>>,
    default: false,
  },
  /**Оценка задачи */
  isEstimate: { type: Boolean },
},
  emits: ["update:formData", "saveTaskName", "saveTaskTags", "saveTaskPerformers", "saveTaskObservers", "saveTaskDescription", "showAllSubtasks", "removeSubtask", "attachSubtask", "onClickCreate", "attachFiles", "removeFile", "updateFileName", "attachParentTask", "unattachParentTask", "changeParentTask", "copyId", "copyName", "copyTaskLink", "openEditImage", "createdSubtask", "updatedSubtask"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;



const emitUpdateFileName = (fileId: number, fileName: string) =>
  emit('updateFileName', fileId, fileName);


const router = useRouter();

/**Является ли текущий юзер овнером */
const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);

/**Элемент обертки */
const $wrapper = inject('wrapperElement') as Ref<HTMLDivElement>;
/**Ссылка на элемент редактора */
const $editor = ref<any>();

/**Ссылка на комненент с подзадачами */
const $subtasks = ref<HTMLElement>();
/**Ссылка на DOM конца блока подзадач */
const $subtasksEndBlock = ref<HTMLElement>();
/**Ссылка на компонент TaskRelations*/
const $taskRelations = ref<InstanceType<typeof TaskRelations>>();

/**Ссылка на скролл */
const $scrollbar = ref<InstanceType<typeof TirPmScrollbar>>();
/**Сссылка на компонент */
const $dialogModal = ref<ComponentInstance<typeof TaskDialogModal>>();

/**Ссылка на задачу weeek */
const weeekTaskUrl = computed(() =>
  props.editTaskInfo?.WeeekTask?.WeeekTaskId !== undefined &&
  props.editTaskInfo.WeeekTask?.WeeekWorkspaceId !== undefined
    ? `https://app.weeek.net/ws/${props.editTaskInfo.WeeekTask.WeeekWorkspaceId}/task/${props.editTaskInfo.WeeekTask.WeeekTaskId}`
    : undefined,
);

const authorTask = props.employees.find((e) => e.Id == props.editTaskInfo?.OwnerId);

const files = computed(() => {
  const formDataFiles = props.formData.Files.filter(
    (file) => !props.uploadingFiles.some((_uploadFile) => file.Id === _uploadFile.Id),
  );
  return [...formDataFiles, ...props.uploadingFiles];
});

const setValue = <T extends keyof TaskFormDataModel>(key: T, value: TaskFormDataModel[T]) => {
  const data = new TaskFormDataModel({
    ...props.formData,
    [key]: value,
  });
  emit('update:formData', data);
};

const updateTaskName = (value: string) => {
  setValue('Name', value);
  emit('saveTaskName');
};

/**Режим редактирования */
const isEditMode = computed(() => !!props.editTaskInfo);
/**Режим инпута */
const inputMode = ref(
  props.editTaskInfo ? TaskInputNameModeEnum.View : TaskInputNameModeEnum.Create,
);
/**Режим поля ввода описания */
const descriptionIsEditMode = ref(!props.editTaskInfo);
/**Раскрыто ли полностью описание */
const isExpandDescription = ref(false);
/**Предыдущее значение описания */
const previousDescription = ref<string>();

const computedNameFotoCurrentUser = computed(() => {
  return CurrentUser?.FirstName?.[0]?.toUpperCase() + CurrentUser?.LastName?.[0]?.toUpperCase();
});
/**Список исполнителей для мультиселекта */
const multiselectPerformers = computed(() =>
  props.editing ? props.employees : props.formData.Performers,
);
/**Список наблюдателей для мультиселекта */
const multiselectObservers = computed(() =>
  props.editing ? props.employees : props.formData.Observers,
);
/**Были ли сохранены изменения в описании */
const isChangedDescription = computed(
  () => previousDescription.value == props.formData.Description,
);

/**Заголовок */
const title = computed(() => {
  if (!isEditMode.value) return 'Новая задача';
  if (props.editTaskInfo?.DateCreate && props.editTaskInfo?.DateUpdate) {
    const dateCreate = props.editTaskInfo.DateCreate;
    const dateUpdate = props.editTaskInfo.DateUpdate;
    return `Создано ${tirPmDateTransform(dateCreate).format(
      'DD.MM.YYYY',
    )}, обновлено ${tirPmDateTransform(dateUpdate).format('DD.MM.YYYY')} в ${tirPmDateTransform(
      dateUpdate,
    ).format('HH:mm')}`;
  }
});

/**Скопировать ссылку на задачу */
const copyTaskLink = async () => {
  if (!props.editTaskInfo.ProjectId || !props.editTaskInfo.QueueTaskId) return;

  const to = router.resolve({
    name: 'task-detail',
    params: {
      projectId: props.editTaskInfo.ProjectId,
      queueId: props.editTaskInfo.QueueTaskId,
      taskId: props.editTaskInfo.Id,
    },
  }).href;

  const origin =
    window.location.hostname === 'localhost' ? 'https://beta.hub-pm.com' : window.location.origin;

  const link = origin + to;
  const textContent = `${props.editTaskInfo.Id}`;
  await copyToClipboard(`[${textContent}](${link})`);
  addNotification('Ссылка на задачу сопирована');
};
const editorFiles = computed<Array<ITextEditorFile>>(() => {
  const a = files.value.map((file) => ({
    FileId: file.Id,
    Url: file.Url,
    VideoPreviewUrl: file.VideoPreviewUrl,
    Name: file.Name,
    Size: file.Size,
    DateUpload: file.DateUpload,
    Progress: file.UploadProgress,
    User: {
      Id: file.User.Id,
      FirstName: file.User.FirstName,
      LastName: file.User.LastName,
      MiddleName: file.User.MiddleName,
      AvatarColor: file.User.AvatarColor,
      Image: file.User.ImageUrl,
    },
    Accesses: file.IsSendingLastChunk
      ? []
      : [FilePreviewAccessEnum.Edit, FilePreviewAccessEnum.Remove],
    IsProccessing: file.IsProccessing,
  }));
  return a;
});

const editorFileForPreview = computed(() =>
  editorFiles.value.map((file) => ({
    ...file,
    Accesses: file.Accesses?.length ? [FilePreviewAccessEnum.Edit] : [],
  })),
);

watch(
  () => isEditMode.value,
  () => {
    if (isEditMode.value) {
      inputMode.value = TaskInputNameModeEnum.View;
    }
  },
);

const onRemoveFile = (fileId: number, fromDescription: boolean) => {
  const isUploadFile = props.uploadingFiles.some((file) => file.Id === fileId);
  if (isUploadFile) {
    FileManager.cancel({ FileId: fileId });
    return;
  }
  emit('removeFile', fileId, fromDescription);
};

/**Добавление подзадачи */
const attachSubtask = (value) => {
  emit('attachSubtask', value);
  setTimeout(() => {
    scrollToElementTop($subtasksEndBlock.value);
  }, 500);
};
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};

/**При добавление очереди */
const attachQueue = () => {
  setTimeout(() => {
    scrollToElementTop($subtasksEndBlock.value);
  }, 500);
};

/**Спуститься до нужного контейнера */
const scrollToElementTop = (el: HTMLElement): void => {
  const scrollContainer = $scrollbar.value.$scroll;
  const currentScrollTop = scrollContainer.scrollTop;
  const targetScrollTop =
    currentScrollTop +
    el.getBoundingClientRect().top -
    scrollContainer.getBoundingClientRect().top -
    20;

  // Если текущая позиция совпадает с целевой, не прокручивать
  if (currentScrollTop === targetScrollTop) return;

  // Плавно прокручиваем контейнер
  scrollContainer.scrollTo({
    top: targetScrollTop,
    behavior: 'smooth',
  });
};

/**Открыт ли дропдаун поиска задач */
const isOpenedTaskSearchDropdown = ref(false);

/**Стили блока подзадач */
const subtasksElementStyle = computed<CSSProperties>(() => {
  let paddingBottom = 58;
  if (isOpenedTaskSearchDropdown.value) {
    paddingBottom += 273;
    paddingBottom -= 49.33 * props.subtasks.length;
    if (!props.isViewAllSubtasks && props.subtasks.length) paddingBottom -= 50;
  }
  return { paddingBottom: `${paddingBottom / 16}rem` };
});

const onClickSaveDescription = () => {
  emit('saveTaskDescription');
  if (isEditMode.value) {
    descriptionIsEditMode.value = false;
    previousDescription.value = props.formData.Description;
  }
};

const onClickCancelSaveDescription = async () => {
  if (!isChangedDescription.value) {
    const responce = await $dialogModal.value.open(TaskDialogEnum.CancelDescriptionChanges);
    if (!responce) {
      resetDescriptionEditMode();
    }
    return;
  }
  if (isEditMode.value) {
    resetDescriptionEditMode();
  }
};
/**Сброс режима редактировании описания */
const resetDescriptionEditMode = () => {
  descriptionIsEditMode.value = false;
  props.formData.Description = previousDescription.value;
};

// Функция возврата
const goBack = () => {
  if (router.options.history.state.back) {
    router.go(-1);
  } else {
    router.push({
      name: 'queue',
    });
  }
};

// Обработчик для кнопки "Назад" в браузере
const handlePopState = () => {
  goBack();
};

const parentScrollContainer: string = inject('parent-scroll-container');
const isShowFloatButton = ref<boolean>(false);

const checkScrollParentPosition = (e: Event) => {
  let parentContainerScrollTop: HTMLElement = e.target as HTMLElement;
  isShowFloatButton.value = parentContainerScrollTop.scrollTop > 470;
};
/**Закрыть оценку задачи */
const closeEstimate = () => {
  router.push({ name: 'projects' });
};

__expose({
  $editor,
  $taskRelations,
});

onMounted(() => {
  previousDescription.value = props.formData.Description;
  document
    .querySelector(parentScrollContainer)
    ?.addEventListener('scroll', checkScrollParentPosition);
});
onUnmounted(() => {
  document
    .querySelector(parentScrollContainer)
    ?.removeEventListener('scroll', checkScrollParentPosition);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.isEstimate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(" Оценка задачи "),
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Regular,
              onClick: closeEstimate
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(CrossCompactIcon))
              ]),
              _: 1
            }, 8, ["variant", "size"])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(TirPmButton), {
              class: "task-main-detail__arrow-uturn-left-icon",
              size: _unref(TirPmButtonSizeEnum).Regular,
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              onClick: goBack
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(ArrowUturnLeftIcon))
              ]),
              _: 1
            }, 8, ["size", "variant"]),
            (isEditMode.value)
              ? (_openBlock(), _createBlock(_unref(TaskMorePopover), {
                  key: 0,
                  userAccess: __props.userAccess,
                  task: __props.editTaskInfo,
                  "task-id": __props.editTaskInfo.Id,
                  "project-id": __props.editTaskInfo.ProjectId,
                  "task-name": __props.editTaskInfo.Name,
                  isParentalTask: !!__props.editTaskInfo.Parent,
                  attachedQueues: !!__props.editTaskInfo.QueueToTaskRelationList?.length,
                  subtasks: __props.subtasks,
                  isSubtasks: !!__props.editTaskInfo?.SubtaskCount,
                  timerTrackerRecords: __props.timerTrackerRecords,
                  "parent-task-id": __props.editTaskInfo.Parent?.Id,
                  "search-tasks-function": __props.searchTasksChangeParent,
                  "is-loading-unattach-button": __props.isLoadingUnattachParent,
                  "custom-position": {
            left: '0rem',
            top: '$el:height + 0.25rem',
          },
                  editing: __props.editing,
                  "show-remove": __props.userAccess.IsProjectAdmin || __props.userAccess.IsOwner,
                  onAttachParentTask: _cache[0] || (_cache[0] = ($event: any) => (emit('attachParentTask', $event))),
                  onChangeParentTask: _cache[1] || (_cache[1] = ($event: any) => (emit('changeParentTask', $event))),
                  onUnattachParentTask: _cache[2] || (_cache[2] = ($event: any) => (emit('unattachParentTask'))),
                  onCopyTaskLink: _cache[3] || (_cache[3] = ($event: any) => (emit('copyTaskLink'))),
                  onSuccessRemove: goBack
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TirPmButton), {
                      variant: _unref(TirPmButtonVariantEnum).LinkState,
                      size: _unref(TirPmButtonSizeEnum).Regular
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(EllipsisHorizontalIcon))
                      ]),
                      _: 1
                    }, 8, ["variant", "size"])
                  ]),
                  _: 1
                }, 8, ["userAccess", "task", "task-id", "project-id", "task-name", "isParentalTask", "attachedQueues", "subtasks", "isSubtasks", "timerTrackerRecords", "parent-task-id", "search-tasks-function", "is-loading-unattach-button", "editing", "show-remove"]))
              : _createCommentVNode("", true),
            (__props.editTaskInfo?.Parent)
              ? (_openBlock(), _createBlock(_unref(TaskParentView), {
                  key: 1,
                  "parent-task": __props.editTaskInfo.Parent,
                  "is-loading-unattach": __props.isLoadingUnattachParent,
                  onUnattach: _cache[4] || (_cache[4] = ($event: any) => (emit('unattachParentTask')))
                }, null, 8, ["parent-task", "is-loading-unattach"]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    (__props.editTaskInfo?.Parent)
      ? (_openBlock(), _createBlock(_unref(TirDivider), { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (!isEditMode.value)
            ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                key: 0,
                size: _unref(TirPmButtonSizeEnum).Small,
                variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                "is-disabled": __props.isDisableCreateButton,
                "is-loading": __props.isLoadingCreateButton,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('onClickCreate')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Создать ")
                ]),
                _: 1
              }, 8, ["size", "variant", "is-disabled", "is-loading"]))
            : _createCommentVNode("", true),
          (__props.editTaskInfo?.Id)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(['task-main-detail__author', { 'is-have-id': !!__props.editTaskInfo?.Id }]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('copyId')))
              }, [
                _createVNode(_unref(TirPmTooltipElement), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TirPmIconView), {
                      size: 24,
                      isRounded: "",
                      isBordered: false,
                      colorCode: __props.editTaskInfo?.Owner?.AvatarColor,
                      imageLoadUrl: __props.editTaskInfo?.Owner?.Photo
                    }, {
                      mainSlot: _withCtx(() => [
                        _createTextVNode(_toDisplayString(computedNameFotoCurrentUser.value), 1)
                      ]),
                      _: 1
                    }, 8, ["colorCode", "imageLoadUrl"])
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(__props.editTaskInfo.Owner.LastName) + " " + _toDisplayString(__props.editTaskInfo.Owner.FirstName) + " " + _toDisplayString(__props.editTaskInfo.Owner.MiddleName), 1)
                  ]),
                  _: 1
                }),
                (__props.editTaskInfo?.Id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.editTaskInfo.Id), 1))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (__props.editTaskInfo?.WeeekTask)
            ? (_openBlock(), _createBlock(_unref(WeeekTag), {
                key: 2,
                class: "task-main-detail__weeek-tag",
                href: weeekTaskUrl.value
              }, null, 8, ["href"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(TirPmTooltipElement), null, {
            content: _withCtx(() => [
              _createTextVNode("Скопировать ссылку")
            ]),
            default: _withCtx(() => [
              (__props.editTaskInfo?.Id)
                ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                    key: 0,
                    class: "task-main-detail__copy-button",
                    size: _unref(TirPmButtonSizeEnum).Small,
                    variant: _unref(TirPmButtonVariantEnum).LinkState,
                    onClick: copyTaskLink
                  }, {
                    leftSlot: _withCtx(() => [
                      _createVNode(_unref(LinkIcon))
                    ]),
                    _: 1
                  }, 8, ["size", "variant"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, _toDisplayString(title.value), 1)
        ]),
        (__props.subtasks.length || __props.editTaskInfo?.QueueToTaskRelationList?.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "task-main-detail__count-subtasks",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (scrollToElementTop($subtasks.value)))
            }, " Дочерние тикеты/очереди: " + _toDisplayString(__props.subtasks.length) + "/" + _toDisplayString(__props.editTaskInfo?.QueueToTaskRelationList?.length), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(TirPmScrollbar), {
      ref_key: "$scrollbar",
      ref: $scrollbar,
      class: "task-main-detail__scroll",
      "show-on-hover": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(TaskInputName), {
            isDisabled: !isEditMode.value || !__props.editing,
            "model-value": __props.formData.Name,
            placeholder: "Введите название задачи",
            "error-message": __props.errors?.Name,
            "no-x-padding": "",
            mode: inputMode.value,
            "onUpdate:mode": _cache[8] || (_cache[8] = ($event: any) => ((inputMode).value = $event)),
            "onUpdate:modelValue": updateTaskName,
            onCopyName: _cache[9] || (_cache[9] = ($event: any) => (emit('copyName'))),
            editing: __props.editing
          }, null, 8, ["isDisabled", "model-value", "error-message", "mode", "editing"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(TaskTagsSelect), {
            "model-value": __props.formData.Tags,
            options: __props.tags,
            editing: __props.editing,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (emit('saveTaskTags', $event)))
          }, null, 8, ["model-value", "options", "editing"])
        ]),
        (descriptionIsEditMode.value && __props.editing)
          ? (_openBlock(), _createBlock(_unref(TirPmTextEditorFile), {
              key: 0,
              ref_key: "$editor",
              ref: $editor,
              class: "task-main-detail__editor",
              "model-value": __props.formData.Description,
              label: "Описание",
              "is-hide-main-controls": !isEditMode.value,
              "file-upload-callbak": __props.fileUploadCallbak,
              "all-files": editorFiles.value,
              "files-loading-edit-name": __props.filesLoadingEditName,
              "max-file-size": 100000 * 1024 * 1024,
              scrollArea: _unref($wrapper),
              "header-height": 57,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (setValue('Description', $event))),
              onSave: onClickSaveDescription,
              onCancel: onClickCancelSaveDescription,
              onOnClickDeleteFile: _cache[12] || (_cache[12] = ($event: any) => (onRemoveFile($event as number, true))),
              onOnClickEditFile: _cache[13] || (_cache[13] = ($event: any) => (emit('openEditImage', $event as number))),
              onSaveFileName: emitUpdateFileName
            }, null, 8, ["model-value", "is-hide-main-controls", "file-upload-callbak", "all-files", "files-loading-edit-name", "scrollArea"]))
          : (_openBlock(), _createBlock(_unref(TirPmTextEditorFilePreview), {
              key: 1,
              label: "Описание",
              class: "task-main-detail__editor",
              content: __props.formData.Description,
              "is-expand": isExpandDescription.value,
              "all-files": editorFileForPreview.value,
              "files-loading-edit-name": __props.filesLoadingEditName,
              onToEdit: _cache[14] || (_cache[14] = ($event: any) => (descriptionIsEditMode.value = true)),
              onChangeExpand: _cache[15] || (_cache[15] = ($event: any) => (isExpandDescription.value = !isExpandDescription.value)),
              onOnClickDeleteFile: _cache[16] || (_cache[16] = ($event: any) => (onRemoveFile($event as number, true))),
              onOnClickEditFile: _cache[17] || (_cache[17] = ($event: any) => (emit('openEditImage', $event as number))),
              onSaveFileName: emitUpdateFileName,
              editing: __props.editing
            }, null, 8, ["content", "is-expand", "all-files", "files-loading-edit-name", "editing"])),
        (__props.editing)
          ? (_openBlock(), _createBlock(_unref(TirPmButton), {
              key: 2,
              variant: _unref(TirPmButtonVariantEnum).LinkState,
              size: _unref(TirPmButtonSizeEnum).Small,
              class: _normalizeClass(["task-main-detail__editor-float-button", {
          'task-main-detail__editor-float-button--show':
            isShowFloatButton.value && !descriptionIsEditMode.value,
        }]),
              onClick: _cache[18] || (_cache[18] = ($event: any) => (descriptionIsEditMode.value = true))
            }, {
              leftSlot: _withCtx(() => [
                _createVNode(_unref(PencilSquareIcon))
              ]),
              _: 1
            }, 8, ["variant", "size", "class"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(TaskEmployeeMultiselect), {
            "model-value": __props.formData.PerformerIds,
            employees: multiselectPerformers.value,
            label: "Исполнители",
            editing: __props.editing,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (emit('saveTaskPerformers', $event)))
          }, null, 8, ["model-value", "employees", "editing"]),
          _hoisted_13,
          _createVNode(_unref(TaskEmployeeMultiselect), {
            "model-value": __props.formData.ObserverIds,
            employees: multiselectObservers.value,
            label: "Наблюдатели",
            editing: __props.editing,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (emit('saveTaskObservers', $event)))
          }, null, 8, ["model-value", "employees", "editing"])
        ]),
        _createVNode(_unref(TirDivider), { style: {"margin":"1.5rem 0"} }),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(TaskFiles), {
            files: files.value,
            "is-disabled": !isEditMode.value || !__props.editing,
            "is-loading-attach-button": __props.isLoadingAttachFilesButton,
            "files-loading-edit-name": __props.filesLoadingEditName,
            onAttachFiles: _cache[21] || (_cache[21] = ($event: any) => (emit('attachFiles', $event, false))),
            onRemoveFile: _cache[22] || (_cache[22] = ($event: any) => (onRemoveFile($event, false))),
            onUpdateName: emitUpdateFileName,
            onOpenEditImage: _cache[23] || (_cache[23] = ($event: any) => (emit('openEditImage', $event)))
          }, null, 8, ["files", "is-disabled", "is-loading-attach-button", "files-loading-edit-name"])
        ]),
        _createElementVNode("div", {
          ref_key: "$subtasks",
          ref: $subtasks
        }, [
          (__props.editTaskInfo)
            ? (_openBlock(), _createBlock(_unref(TaskRelations), {
                key: 0,
                ref_key: "$taskRelations",
                ref: $taskRelations,
                userAccess: __props.userAccess,
                taskId: __props.editTaskInfo.Id,
                projectId: __props.editTaskInfo.ProjectId,
                queueId: __props.editTaskInfo.QueueTaskId,
                subtasks: __props.subtasks,
                subtasksCount: __props.editTaskInfo.SubtaskCount,
                queues: __props.editTaskInfo.QueueToTaskRelationList,
                tasksSearchFunction: __props.searchTasksToAttach,
                isEdit: isEditMode.value && __props.editing,
                onAttachSubtask: attachSubtask,
                onAttachQueue: attachQueue,
                onRemoveSubtask: _cache[24] || (_cache[24] = ($event: any) => (emit('removeSubtask', $event))),
                onCreatedSubtask: _cache[25] || (_cache[25] = ($event: any) => (emit('createdSubtask', $event))),
                onUpdatedSubtask: _cache[26] || (_cache[26] = ($event: any) => (emit('updatedSubtask', $event)))
              }, null, 8, ["userAccess", "taskId", "projectId", "queueId", "subtasks", "subtasksCount", "queues", "tasksSearchFunction", "isEdit"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            ref_key: "$subtasksEndBlock",
            ref: $subtasksEndBlock
          }, null, 512)
        ], 512),
        _createVNode(_unref(TaskDialogModal), {
          ref_key: "$dialogModal",
          ref: $dialogModal
        }, null, 512)
      ]),
      _: 1
    }, 512)
  ]))
}
}

})